import { defineMessages } from "react-intl";
const messages = defineMessages({
    scannerNotesTitle: {
        id: "app.scanRequests.table.scannerNotes.title",
        defaultMessage: "Scanner Notes",
    },
    scannerNotesButton: {
        id: "app.scanRequests.table.scannerNotes.button",
        defaultMessage: "Done",
    },
    scannerNotesSubtitle: {
        id: "app.scanRequests.table.scannerNotes.subtitle",
        defaultMessage: "This note was submitted on: {date}",
    },
    scannerNotesSubtitleNoDate: {
        id: "app.scanRequests.table.scannerNotes.subtitle.noDate",
        defaultMessage: "This note has no traceable update's date.",
    },
    scannerNotesStatus: {
        id: "app.scanRequests.table.scannerNotes.status",
        defaultMessage: "Status:",
    },
    scannerNotesReason: {
        id: "app.scanRequests.table.scannerNotes.reason",
        defaultMessage: "Reason:",
    },
    scannerNotesComments: {
        id: "app.scanRequests.table.scannerNotes.comments",
        defaultMessage: "Comments:",
    },
    scannerNotesCancelledBy: {
        id: "app.scanRequests.table.scannerNotes.cancelledBy",
        defaultMessage: "Cancelled by:",
    },
});
export default messages;
